export default __webpack_public_path__ + "static/media/LogoAdaClub.2747f383.jpg";